import { render, staticRenderFns } from "./checkboxNew.vue?vue&type=template&id=2d09650d&scoped=true&"
import script from "./checkboxNew.vue?vue&type=script&lang=js&"
export * from "./checkboxNew.vue?vue&type=script&lang=js&"
import style0 from "./checkboxNew.vue?vue&type=style&index=0&id=2d09650d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d09650d",
  null
  
)

export default component.exports